<template>
  <template v-if="icon === 'ai'">
    <svg
      viewBox="0 0 14 14"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/ai.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'arrow-right'">
    <svg
      viewBox="0 0 11 10"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/arrow-right.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'arrow-up'">
    <svg
      viewBox="0 0 10 11"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/arrow-up.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'audio'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/audio.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'bell'">
    <svg
      viewBox="0 0 14 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/bell.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'binoculars'">
    <svg
      viewBox="0 0 20 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/binoculars.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'book'">
    <svg
      viewBox="0 0 14 14"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/book.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'book-validation'">
    <svg
      viewBox="0 0 14 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/book-validation.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'briefcase'">
    <svg
      viewBox="0 0 15 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/briefcase.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'briefcase-2'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/briefcase-2.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'building'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/building.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'building-plus'">
    <svg
      viewBox="0 0 20 18"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/building-plus.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'calendar'">
    <svg
      viewBox="0 0 14 14"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/calendar.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'cancel'">
    <svg
      viewBox="0 0 13 13"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/cancel.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'certified'">
    <svg
      viewBox="0 0 18 18"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/certified.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'chat'">
    <svg
      viewBox="0 0 24 24"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/chat.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'chart-pie'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/chart-pie.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'check'">
    <svg
      viewBox="0 0 13 13"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/check.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'chevron-down'">
    <svg
      viewBox="0 0 14 8"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/chevron-down.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'chevron-left'">
    <svg
      viewBox="0 0 10 10"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/chevron-left.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'chevron-up'">
    <svg
      viewBox="0 0 14 8"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/chevron-up.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'chevrons-up-down'">
    <svg
      viewBox="0 0 9 14"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/chevrons-up-down.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'chevron-right'">
    <svg
      viewBox="0 0 10 10"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/chevron-right.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'chevron-double-left'">
    <svg
      viewBox="0 0 12 10"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/chevron-double-left.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'chevron-double-right'">
    <svg
      viewBox="0 0 12 10"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/chevron-double-right.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'cinema-clap'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/cinema-clap.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'circle-check-big'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/circle-check-big.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'click'">
    <svg
      viewBox="0 0 13 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/click.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'click2'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/click2.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'clock'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/clock.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'close'">
    <svg
      viewBox="0 0 18 19"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/close.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'collapse'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/collapse.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'contract'">
    <svg
      viewBox="0 0 14 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/contract.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'copy'">
    <svg
      viewBox="0 0 12 13"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/copy.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'dashboard'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/dashboard.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'database'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/database.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'disclaimer'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/disclaimer.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'dot'">
    <svg
      viewBox="0 0 6 6"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/dot.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'dollar-sign'">
    <svg
      viewBox="0 0 13 13"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/dollar-sign.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'dots-vertical'">
    <svg
      viewBox="0 0 4 13"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/dots-vertical.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'download'">
    <svg
      viewBox="0 0 14 14"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/download.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'education'">
    <svg
      viewBox="0 0 15 14"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/education.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'expand'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/expand.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'external-link'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/external-link.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'eye'">
    <svg
      viewBox="0 0 21 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/eye.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'flash'">
    <svg
      viewBox="0 0 13 15"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/flash.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'floppy-disk'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/floppy-disk.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'go-back'">
    <svg
      viewBox="0 0 24 24"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/go-back.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'grid'">
    <svg
      viewBox="0 0 24 24"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/grid.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'handshake'">
    <svg
      viewBox="0 0 14 10"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/handshake.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'handshake2'">
    <svg
      viewBox="0 0 19 11"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/handshake2.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'help'">
    <svg
      viewBox="0 0 14 14"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/help.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'history'">
    <svg
      viewBox="0 0 24 24"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/history.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'info'">
    <svg
      viewBox="0 0 14 14"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/info.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'key'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/key.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'less'">
    <svg
      viewBox="0 0 10 2"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/less.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'layout-dashboard'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/layout-dashboard.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'linkedin'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/linkedin.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'linkedin-users'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/linkedin-users.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'list'">
    <svg
      viewBox="0 0 14 10"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/list.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'list-x'">
    <svg
      viewBox="0 0 15 13"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/list-x.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'loader'">
    <svg
      class="loader"
      viewBox="0 0 18 19"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/loader.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'lock'">
    <svg
      viewBox="0 0 24 24"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/lock.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'mail'">
    <svg
      viewBox="0 0 15 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/mail.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'mail2'">
    <svg
      viewBox="0 0 17 13"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/mail2.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'mail3'">
    <svg
      viewBox="0 0 13 10"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/mail3.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'mail-open'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/mail-open.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'mail-open2'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/mail-open2.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'mail-send'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/mail-send.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'mail-template'">
    <svg
      viewBox="0 0 13 13"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/mail-template.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'map'">
    <svg
      viewBox="0 0 13 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/map.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'megaphone'">
    <svg
      viewBox="0 0 15 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/megaphone.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'mobile'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/mobile.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'multicanal'">
    <svg
      viewBox="0 0 15 15"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/multicanal.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'multicanal-v2'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/multicanal-v2.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'newspaper'">
    <svg
      viewBox="0 0 53 40"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/newspaper.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'newspaper-2'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/newspaper-2.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'paper-plane'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/paper-plane.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'paper-plane-o'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/paper-plane-o.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'package-plus'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/package-plus.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'pause'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/pause.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'pause2'">
    <svg
      viewBox="0 0 10 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/pause2.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'pen-in-square'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/pen-in-square.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'pen-writing'">
    <svg
      viewBox="0 0 18 18"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/pen-writing.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'phone'">
    <svg
      viewBox="0 0 13 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/phone.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'phone2'">
    <svg
      viewBox="0 0 15 15"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/phone2.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'play'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/play.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'play2'">
    <svg
      viewBox="0 0 18 18"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/play2.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'plus'">
    <svg
      viewBox="0 0 13 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/plus.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'pplay'">
    <svg
      viewBox="0 0 12 13"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/pplay.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'poster'">
    <svg
      viewBox="0 0 11 14"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/poster.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'prospects'">
    <svg
      viewBox="0 0 14 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/prospects.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'prospects-x'">
    <svg
      viewBox="0 0 14 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/prospects-x.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'power-off'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/power-off.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'push-to-crm'">
    <svg
      viewBox="0 0 11 11"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/push-to-crm.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'question'">
    <svg
      viewBox="0 0 24 25"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/question.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'refresh'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/refresh.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'radio'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/radio.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'replay'">
    <svg
      viewBox="0 0 12 13"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/replay.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'reply'">
    <svg
      viewBox="0 0 18 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/reply.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'mail-recip'">
    <svg
      viewBox="0 0 14 11"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/mail-recip.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'reply2'">
    <svg
      viewBox="0 0 14 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/reply2.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'reply3'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/reply3.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'save'">
    <svg
      viewBox="0 0 14 14"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/save.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'search'">
    <svg
      viewBox="0 0 12 13"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/search.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'send'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/send.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'send-o'">
    <svg
      viewBox="0 0 18 18"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/send-o.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'settings'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/settings.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'settings2'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/settings2.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'signature'">
    <svg
      viewBox="0 0 14 14"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/signature.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'slashed-eye'">
    <svg
      viewBox="0 0 16 11"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/slashed-eye.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'speaker'">
    <svg
      viewBox="0 0 20 20"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/speaker.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'star'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/star.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'stop'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/stop.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'task'">
    <svg
      viewBox="0 0 13 13"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/task.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'television'">
    <svg
      viewBox="0 0 13 13"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/television.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'thumb-down'">
    <svg
      viewBox="0 0 13 14"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/thumb-down.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'thumb-up'">
    <svg
      viewBox="0 0 13 14"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/thumb-up.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'time'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/time.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'trash'">
    <svg
      viewBox="0 0 13 14"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/trash.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'trending-up'">
    <svg
      viewBox="0 0 16 8"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/trending-up.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'trophy'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/trophy.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'unassign'">
    <svg
      viewBox="0 0 14 13"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/unassign.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'user'">
    <svg
      viewBox="0 0 13 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/user.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'user-plus'">
    <svg
      viewBox="0 0 14 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/user-plus.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'valid'">
    <svg
      viewBox="0 0 12 9"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/valid.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'wifi'">
    <svg
      viewBox="0 0 12 12"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/wifi.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'valid2'">
    <svg
      viewBox="0 0 14 14"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/valid2.svg') + '#Icon'" />
    </svg>
  </template>
  <template v-else-if="icon === 'preheat'">
    <svg
      viewBox="0 0 16 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/preheat.svg') + '#Icon'" />
    </svg>
  </template>

  <template v-else-if="icon === 'robot'">
    <svg
      viewBox="0 0 19 16"
      :width="size"
    >
      <use :href="require('@/assets/icons/nds/robot.svg') + '#Icon'" />
    </svg>
  </template>
</template>

<script>
export default {
  name: 'SvgElement',
  props: {
    icon: String,
    size: [Number, String],
  },
};
</script>

<style scoped>
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.loader {
  animation: rotate 5s linear infinite;
  transform-origin: center;
}
</style>
